export default __webpack_public_path__ + "static/media/laundry2-beforeB-2048w.5841cdbd.webp";